import React, { Component } from 'react';
import Nana from './images/Nana.png';

import { Instagram, Send } from 'react-feather';
import CardImg1 from './images/card1.jpg';
import CardImg2 from './images/card2.jpg';
import CardImg3 from './images/card3.jpg';

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false, 
        }
    }
    render() {
        return (
        <React.Fragment>
            <div className='div1'>
                <div className='div1-r'>
                     <img src={Nana} className='Nana'></img>
                </div>
                <div className='div1-l'>
                     <p style={{ direction: "rtl",fontSize: "1.1em", lineHeight: "2em", }}>
            <       h2>أنا نُها كمّون</h2><br />
                    <span style={{ display: "block", textAlign: "center", fontWeight: "bold",}}>مدرّبة حياة (Life Coach) معتمدة في منهج ®Heal Your Life</span>
                    ومُرشدة في رحلة الشفاء، حب الذات، والتصالح مع الروح والحياة.<br />
                    أحمل رسالة حب وسلام، وأسعى لمرافقة الآخرين في مسار الوعي والتحرر من الألم نحو حياة أكثر إشراقًا واتزانًا.<br />
                    سفيرة الأكاديمية الدولية للتنمية الذاتية <strong>د. صلاح الراشد</strong> وعضو في الاتحاد الدولي للمدرّبين (ICF)،
                     <br /> أقدّم جلسات ودورات وورش عمل ترتكز على التغيير العميق، تحرير المشاعر، وخلق واقع جديد مليء بالإيمان، السعادة، والحرية الداخلية.
                </p>
                </div>
            </div>
            <div className='social'>
            <button className='social_b' onClick={() => window.open('https://www.instagram.com/nohakammoun369/', '_blank')}>Instagram<Instagram /><span>إنستغرام</span></button>
            <button className='social_b' onClick={() => window.open('https://t.me/noha_kammoun', '_blank')}>Telegram<Send /><span>تيليغرام</span></button>
            </div>

            <div className='div2'>
                <div className='div2-1'>
                    <img src={CardImg3} alt="تعلم" className="card-image" />
                    <h2>تعلم</h2>
                    <p>تعلم أكثر عن نفسك ومحيطك .تعلم أكثر عن الأشياء التي انت تحبها وتثير إنتباهك.
                    تعلم العلم الذي يساعدك على إدراك مكامن قوتك وتعلم كيف تحسن من نقاط الضعف التي لديك .
                    تعلم كيف تحب نفسك أكثر.
                    تعلم كيف تكون واعي بأفكارك وكلماتك ونفسك.
                    تعلم كيف تتجاوز مخاوفك  لتكون إنسان واثق شجاع.
                    </p>           
                </div>

                <div className='div2-1'>
                    <img src={CardImg2} alt="تعلم" className="card-image" />
                   <h2>إكتشف</h2>
                    <p>إكتشف قدراتك الداخلية وإكتشف ما أنت قادر عليه
                    إكتشف نفسك وإكتشف اسباب وجودك هنا
                    إكتشف حياتك وما هو الذي يحركك
                    إكتشف ما هي الأشياء التي تسعدك
                    إكتشف ما الذي أنت بارع فيه وتحبه
                    إكتشف الأصدقاء الحقيقين
                    إكتشف  قوتك وتألق
                    إكتشف كنوزك فتنجح
                    </p>           
                </div>

                <div className='div2-1'>
                     <img src={CardImg1} alt="تعلم" className="card-image" />
                   <h2>تشافى</h2>
                    <p>
                    تشافى وتعافى من ألمك ومصابك, خسارتك, أحزانك, أوقف معاناتك تستطيع تعرف على الطريقة ,تعرف على الذي تجهله, خذ خطوة تجاه تحسين أفكارك مشاعرك سلوكياتك تصرفاتك فتتغير حياتك 
                    تشافى تعافى فتسعد
                    </p>  
                </div>

            </div>         
        </React.Fragment>
        );
    }
}
export default Home;